module.exports = __webpack_public_path__ + "img/index_user_bg.7cee75c0.png";